import { LearnLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn._context";
import { toDiacriticPinyin } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";
import { setText as setPersistentKeyboardText } from "@-/dev.improve.haniverse.modules.persistent-keyboard";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useCallback } from "react";

export function usePinyinPreviewChange() {
  const [setAnswerInputState] = useContextSelectors(
    LearnLayoutContext,
    (c) => c.setAnswerInputState,
  );

  return useCallback(
    (value: string) => {
      // The pinyin input is now the shared native persistent keyboard field; the shuangpin grid
      // writes into the same store so typing on either source stays in sync. Tone digits are an
      // internal encoding the user shouldn't see — render the diacritic form in the input.
      const displayValue = value.trim().length === 0 ? value : toDiacriticPinyin(value);
      setPersistentKeyboardText(displayValue, value);
      setAnswerInputState((prev) => ({
        ...prev,
        validationState: null,
      }));
    },
    [setAnswerInputState],
  );
}
